import React from 'react';

import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';

import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import UserStore from '../../util/UserStore';
import { isMobile, isTablet, isBrowser  } from 'react-device-detect';
import $ from 'jquery';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import loginIcon from '../../images/icons/loginicon.png';

var loginServerResponses = {
		 200: 'Success.',
		  600: 'User ID expired.',
		  700: 'Invalid User ID or Password.',
		  500: 'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:<email>"><email></a>.',
		  0: 'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>.'
};

class LumosLoginForm extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {
				username: '',
				password: '',     
				submitButtonDisabled: false,
				serverMessage: "",
				source:"lumos"
		};

		this.handleChange = this.handleChange.bind(this);
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.submitForm = this.submitForm.bind(this);
		this.showforgotPwd = this.showforgotPwd.bind(this);

		this.myTrackerInstance = this.getTracker();
	}

	componentDidMount(){
		this.sessionCheck();
	} 
	
	handleForgotPwd(){
		
	}

	handleChange(e) {
		const target = e.currentTarget;	
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			submitButtonDisabled: !this.form.isValid()
		});
	}

	handlePasswordChange(e) {    
		this.handleChange(e);
	}

	hmNav = function(){
		//this.props.history.push('/landing');
		this.props.myProps.history.push('/landing');
	}

	submitForm = function(){
		var me =this;	
		var formData = {
				"userId":this.state.username,
				"password":this.state.password
		}
		me.setState({submitButtonDisabled: true});
		$.ajax({
	            url: me.getUrlFor("LUMOS_LOGIN"),
	            data: formData,
	            type: 'POST',
	            xhrFields: {
			       withCredentials: true
			    },
			    crossDomain: true,
	            success: function(response){	            	
	    			 switch (response.code) {
			            case 200:
			            case 402:
			            	window.top.location.href = response.link;
			            break;
			            case 500:
			              //currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.codeus].replace(/<email>/g, response.link);
			            	me.setState({ submitButtonDisabled: false, serverMessage: loginServerResponses[response.code].replace(/<email>/g, response.link)});
			            break;
			            case 600:
			            case 700:
			              //currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.code];
			            	me.setState({ submitButtonDisabled: false, serverMessage: loginServerResponses[response.code] });
			            break;
			            default:
			              //currentDialog.serverMessageElem.innerHTML = loginServerResponses[0];
			            	me.setState({ submitButtonDisabled: false, serverMessage: loginServerResponses[0]});
			          }
	    		},
	            error: function(response){
	    			console.log("Error in lumos login",response);
	    			me.setState({submitButtonDisabled: false});
	    		}
	    });
		
	}
	
	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid(), serverMessage: "" });
		
		if (this.form.isValid()) {   


			this.submitForm();    


		}
	}
	showforgotPwd(){
		this.props.callbackForgotPwd(this.state.source)
	}
	
	render() {
		if(this.state.loggedIn){
			return super.render();
		} else { return (
				
				<div className="row nomargin loginParent">
					<div className="col-sm-4 nopadding loginLeftSection">
						<h1 className="loginLeftContent">{this.rb("signincaptital")}</h1>
						<div className="charactercontainer d-none d-sm-block">
							<img className="charactericons loginIcon" src={loginIcon} />
						</div>
					</div>
					
					<div id="loginRoot" className="col-sm-8">
					
					<div className="container">
					
					<div className="row">
					<div className="col-md-12">
	
					<div className="row">
					<div className="col-md-12 mx-auto nopadding">
					<div className="rounded-0">
	
					<div className="text-center">
					
					<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
					onSubmit={this.handleSubmit} noValidate>
					<FormGroup for="username">
	
					<FormControlInput type="username" className="username" name="username" placeholder={this.rb("login.userid")}
						value={this.state.username} onChange={this.handleChange}
					required minLength={1} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
						<FieldFeedbacks for="username">
					<FieldFeedback when="valueMissing">{this.rb("login.useridrequired")}</FieldFeedback>
					<FieldFeedback when="*" />
						</FieldFeedbacks>
					</FormGroup>
	
					<FormGroup for="password">
	
					<FormControlInput type="password" className="password" name="password" placeholder={this.rb("login.password")}
						innerRef={password => this.password = password}
					value={this.state.password} onChange={this.handlePasswordChange}
					required minLength={1} tabIndex="2"/>
						<FieldFeedbacks for="password" show="all">
					<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>
					</FieldFeedbacks>
					</FormGroup>
					<div data-ga="Home - Sign in - Users enrolled through school - Forgot Password" className="text-right forgotPassword josefinsansFont" onClick={this.showforgotPwd}>
						{this.rb("forgot_password")}
					</div>
					
					<div className="server-messages">{ReactHtmlParser(this.state.serverMessage)}</div>
					 
					<button data-ga="Home - Sign in - Users enrolled through school - Sign In" disabled={this.state.submitButtonDisabled} className="submitButton">{this.rb("signin")}</button>
					</FormWithConstraints>	
					</div>
					</div>
					</div>
	
	
					</div>
	
					</div>
					</div>
					</div>
					</div>
				</div>
		);}
	}
}

export default LumosLoginForm;



// WEBPACK FOOTER //
// ./src/views/login/LumosLoginForm.js